import React, {useState, useEffect, useCallback} from "react";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

import Header from "../components/js/Header";
import Input from "../components/js/Input";

import "../css/ProductBarEdit.css"
import "../css/Ads.css"
import '../components/css/Tables.css'
import '../css/Analytics.css'


import {useDispatch, useSelector} from "react-redux";
import {
    displayDateUTC,
    isSessionValid,
    parseMapCaretChars
} from "../helpers/helpers";
import {Redirect} from "react-router";
import {PAGES} from "../App";
import {
    loadAddImpressionsRegionally, loadAvgPrices,
    loadDailyQRScans,
    loadHourlyQRScans, loadHourlyQRScansByBars,
    loadRegionallyQRScans,
    setSidebarWidth,

} from "../store/actions/actions";
import {useHistory} from "react-router-dom";
import Page, {SIDEBAR_WIDTH} from "../components/js/Page";
import Button from "../components/js/Button";
import {
    BarChart,
    Bar,
    Cell,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';
import BarQrScansDropdown from "../components/js/BarQrScansDropdown";

// in pixels as integer
export const BANNER_WIDTH = 350;

export const ITEMS_PER_PAGE = 30;
export const TIMEOUT_INTERVAL = 1;

const SEARCH_BY_FIELDS = [
    'name',
    'external_id'
];


function Analytics(props) {
    let dispatch = useDispatch();

    let token = useSelector(state => state.reducer.userToken);
    let user = useSelector(state => state.reducer.user);
    const sidebarWidth = useSelector(state => state.reducer.sidebarWidth);
    let ads = useSelector(state => state.reducer.ads);

    const [productSelected, setProductSelected] = useState(null);
    const [categorySelected, setCategorySelected] = useState(null);

    const [dataQrScansDailySum, setDataQrScansDailySum] = useState(0);

    const [dataQrScansDaily, setDataQrScansDaily] = useState([]);
    const [dataQrScansHourly, setDataQrScansHourly] = useState([]);
    const [dataQrScansByBarsHourly, setDataQrScansByBarsHourly] = useState([]);

    const [selectedBarForHourlyQrScans, setSelectedBarForHourlyQrScans] = useState(null);


    const [dataQrScansRegionally, setDataQrScansRegionally] = useState([]);
    const [adsImpressions, setAdsImpressions] = useState([]);
    const [averageProductPrices, setAverageProductPrices] = useState([]);
    const [averageCategoryPrices, setAverageCategoryPrices] = useState([]);

    const [period, setPeriod] = useState("ALL_TIME");

    const [tab, setTab] = useState(false);
    const [tabPrices, setTabPrices] = useState(false);

    const [allProductPrices, setAllProductPrices] = useState(averageProductPrices);
    const [allCategoryPrices, setAllCategoryPrices] = useState(averageCategoryPrices);

    const [filteredAverageProductPrices, setFilteredAverageProductPrices] = useState(averageProductPrices);
    const [filteredAverageCategoryPrices, setFilteredAverageCategoryPrices] = useState(averageCategoryPrices);
    const [nameInput, setNameInput] = useState(null);

    const [inputTimeout, setInputTimeout] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const [showStatsForSelectedBar, setShowStatsForSelectedBar] = useState(false);
    const [showCalendarModal, setShowCalendarModal] = useState(false); // Added state for calendar modal

    /* DATE RANGE */
    const [dateRange, setDateRange] = useState([new Date(), new Date()]);
    const [startDate, endDate] = dateRange;

    let history = useHistory();
    const onNavigateTo = useCallback(((path) => {
        history.push(path);
    }), [history]);


    useEffect(() => {
        window.analytics_page_open = true;

        return () => {
            window.analytics_page_open = false;
        };
    }, []);

    useEffect(() => {
        if (!!inputTimeout) {
            clearTimeout(inputTimeout);
            setInputTimeout(null);
        }
        setInputTimeout(setTimeout(() => {
            if (!nameInput || nameInput === '' || (nameInput && nameInput?.length <= 2)) {
                dispatch(loadAvgPrices(user.user_id, (resData) => {
                    setFilteredAverageProductPrices(resData.products);
                    setFilteredAverageCategoryPrices(resData.categories);

                    setAllProductPrices(resData.products);
                    setAllCategoryPrices(resData.categories);

                    //  console.log(resData)

                }, () => {
                    console.warn("Error loading data..")
                }));
            } else {
                let searched = [];
                let searchedSecondArray = [];
                for (const s of allProductPrices) {
                    for (const fieldName of SEARCH_BY_FIELDS) {
                        if (s.hasOwnProperty(fieldName) && !!s[fieldName] && parseMapCaretChars(s[fieldName]).toLowerCase().includes(nameInput.toLowerCase())) {
                            searched.push(s);
                            break;
                        }
                    }
                }
                for (const s of allCategoryPrices) {
                    for (const fieldName of SEARCH_BY_FIELDS) {
                        if (s.hasOwnProperty(fieldName) && !!s[fieldName] && parseMapCaretChars(s[fieldName]).toLowerCase().includes(nameInput.toLowerCase())) {
                            searchedSecondArray.push(s);
                            break;
                        }
                    }
                }
                setFilteredAverageProductPrices(searched);
                setFilteredAverageCategoryPrices(searchedSecondArray);
            }
            //setCurrentPage(1);
        }, TIMEOUT_INTERVAL));
    }, [nameInput]);

    useEffect(() => {
        if (filteredAverageProductPrices.length < ITEMS_PER_PAGE) {
            setAverageProductPrices(filteredAverageProductPrices);
        } else {
            setAverageProductPrices(filteredAverageProductPrices.slice((currentPage - 1) * ITEMS_PER_PAGE, (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE));
        }
    }, [currentPage, filteredAverageProductPrices, tabPrices]);

    useEffect(() => {
        if (filteredAverageCategoryPrices.length < ITEMS_PER_PAGE) {
            setAverageCategoryPrices(filteredAverageCategoryPrices);
        } else {
            setAverageCategoryPrices(filteredAverageCategoryPrices.slice((currentPage - 1) * ITEMS_PER_PAGE, (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE));
        }
    }, [currentPage, filteredAverageCategoryPrices, tabPrices]);

    // Reset date range when changing period from CUSTOM_TIME to something else
    useEffect(() => {
        if (period !== "CUSTOM_TIME") {
            // Reset to current date if switching away from custom time
            setDateRange([new Date(), new Date()]);
        }
    }, [period]);

    // Load QR scan data when period or date range changes
    useEffect(() => {
        const loadQRScanData = async () => {
            if (user && period) {
                // Prepare date parameters for CUSTOM_TIME period
                let startDateParam = null;
                let endDateParam = null;

                if (period === "CUSTOM_TIME" && startDate && endDate) {
                    // Normalize start and end dates to cover the full day
                    let start = new Date(startDate);
                    start.setHours(0, 0, 0, 0);
                    startDateParam = start.toISOString();

                    let end = new Date(endDate);
                    end.setHours(23, 59, 59, 999);
                    endDateParam = end.toISOString();
                }

                console.log("START DATE param", startDateParam);
                console.log("END DATE param", endDateParam);

                await dispatch(loadDailyQRScans(period, startDateParam, endDateParam, (resData) => {
                    setDataQrScansDaily(resData);
                    // Calculate the sum of all QR scans from the daily data
                    if (resData && resData?.length > 0) {
                        const sum = resData.reduce((total, item) => total + parseInt(item.qr_scans, 10), 0);
                        setDataQrScansDailySum(sum);
                    } else {
                        setDataQrScansDailySum(0);
                    }

                    console.log("API CALL QR SCANS [DAILY]", resData);
                }, () => {
                    console.warn("Error loading daily QR scan data");
                    setDataQrScansDailySum(0);
                }));

                await dispatch(loadHourlyQRScans(period, startDateParam, endDateParam, (resData) => {
                    if (resData && resData?.length > 0) {
                        // Check if all qr_scans values are 0
                        const allZeros = resData.every(item => parseInt(item.qr_scans, 10) === 0);

                        // If all values are 0, set to empty array to trigger "no data" display
                        if (allZeros) {
                            setDataQrScansHourly([]);
                        } else {
                            setDataQrScansHourly(resData);
                        }
                    } else {
                        setDataQrScansHourly([]);
                    }

                    console.log("API CALL QR SCANS [HOURLY]", resData);
                }, () => {
                    setDataQrScansHourly([]);
                    console.warn("Error loading hourly QR scan data");
                }));

                await dispatch(loadHourlyQRScansByBars(period, startDateParam, endDateParam, (resData) => {
                    if (resData && resData?.length > 0) {
                        setDataQrScansByBarsHourly(resData);
                    } else {
                        setDataQrScansByBarsHourly([]);
                    }
                    console.log("API CALL QR SCANS [HOURLY BY BAR]", resData);
                }, () => {
                    setDataQrScansByBarsHourly([]);
                    console.warn("Error loading hourly QR scan by bars data");
                }));

                await dispatch(loadRegionallyQRScans(user.user_id, period, startDateParam, endDateParam, (resData) => {
                    setDataQrScansRegionally(resData);
                    console.log("API CALL QR SCANS [REGIONAL]", resData);
                }, () => {
                    console.warn("Error loading regional QR scan data");
                    setDataQrScansRegionally([]);
                }));
                
                await dispatch(loadAddImpressionsRegionally(user.user_id, period, startDateParam, endDateParam, (resData) => {
                    if (resData && resData?.length > 0) {
                        setAdsImpressions(resData);
                    } else {
                        setAdsImpressions([]);
                    }
                    console.log("API CALL AD IMPRESSIONS", resData);
                }, () => {
                    console.warn("Error loading ad impressions data");
                    setAdsImpressions([]);
                }));
            }
        };

        loadQRScanData();
    }, [user, period, startDate, endDate, dispatch]);

    // Load data that doesn't depend on date range (only needs to be loaded when user changes)
    useEffect(() => {
        const loadNonDateDependentData = async () => {
            if (user) {
                await dispatch(loadAvgPrices(user.user_id, (resData) => {
                    setAverageProductPrices(resData.products);
                    setAverageCategoryPrices(resData.categories);

                    setFilteredAverageProductPrices(resData.products);
                    setFilteredAverageCategoryPrices(resData.categories);

                    setAllProductPrices(resData.products);
                    setAllCategoryPrices(resData.categories);
                    console.log("API CALL AVG PRICES", resData);
                }, () => {
                    console.warn("Error loading average prices data");
                }));
            }
        };

        loadNonDateDependentData();
    }, [user, dispatch]);

    const formatDatesInData = (data) => {
        return data.map(item => {
            // console.log("Formatting date:", item.date);
            const formattedDate = displayDateUTC(item.date);
            return {...item, date: formattedDate};
        });
    };

    const renderScansDaily = () => {
        if (!dataQrScansDaily || dataQrScansDaily.length === 0) {
            console.log("No daily scan data available.");
            return <></>;
        }

        const tmpData = formatDatesInData(dataQrScansDaily);
        console.log("DAILY SCANS after formatting:", tmpData);

        return (
            <div style={{height: '200px'}}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        width={500}
                        height={300}
                        data={tmpData}
                        margin={{top: 10, right: 10, left: 10, bottom: 10}}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="date"/>
                        <YAxis/>
                        <Tooltip/>
                        <Line
                            type="monotone"
                            name="QR SKENIRANJ"
                            dataKey="qr_scans"
                            stroke="#82ca9d"
                            activeDot={{r: 4}}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        );
    };

    const renderScansHourly = () => {
        if (!dataQrScansHourly || dataQrScansHourly.length === 0) {
            console.log("No hourly scan data available.");
            return <p className={'p-stats-info'}>Za izbrano časovno obdobje ni podatkov.</p>;
        }
        console.log("HOURLY SCANS:", dataQrScansHourly);

        const maxQrScans = Math.max(...dataQrScansHourly.map(item => Number(item.qr_scans)));

        return (
            <div style={{height: '200px'}}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        width={500}
                        height={300}
                        data={dataQrScansHourly}
                        margin={{top: 10, right: 10, left: 10, bottom: 10}}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="hour"/>
                        <YAxis domain={[0, maxQrScans]}/>
                        <Tooltip/>
                        <Bar name="QR SKENIRANJ" dataKey="qr_scans" fill="#82ca9d"/>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        );
    };


    const renderScansByBarHourly = () => {
        if (!selectedBarForHourlyQrScans || !selectedBarForHourlyQrScans?.hourly_stats) {
            return <p className={'p-stats-info'}>Za izbrani bar in časovno obdobje ni podatkov.</p>;
        }

        const maxQrScans = Math.max(...selectedBarForHourlyQrScans.hourly_stats.map(item => item.qr_scans));

        return (
            <div style={{height: '200px'}}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        width={500}
                        height={300}
                        data={selectedBarForHourlyQrScans.hourly_stats}
                        margin={{
                            top: 10,
                            right: 10,
                            left: 10,
                            bottom: 10,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="hour"/>
                        <YAxis domain={[0, maxQrScans]}/>
                        <Tooltip/>
                        <Bar name={`QR skeniranja za ${parseMapCaretChars(selectedBarForHourlyQrScans.name)}`}
                             dataKey="qr_scans"
                             fill="#82ca9d"/>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        );
    };


    const renderScansRegionally = () => {
        console.log("REFGIONAL QR SCANS:", dataQrScansRegionally);
        if (!dataQrScansRegionally || dataQrScansRegionally?.length === 0) {
            return <p className={'p-stats-info'}>Za izbrano časovno obdobje ni podatkov.</p>;
        }

        return (
            <div style={{height: '160px'}}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        width={500}
                        height={300}
                        data={dataQrScansRegionally}
                        margin={{
                            top: 10,
                            right: 10,
                            left: 10,
                            bottom: 10,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="region"/>
                        <YAxis/>
                        <Tooltip/>
                        <Bar name="QR SKENIRANJ" dataKey="qr_scans" fill="#82ca9d"/>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        );
    }
    
    const renderAdImpressionsRegionally = (regions) => {
        return (
            <div style={{height: '140px', width: '300px'}}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        width={500}
                        height={300}
                        data={regions}
                        margin={{
                            top: 10,
                            right: 10,
                            left: 10,
                            bottom: 10,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="region"/>
                        <YAxis/>
                        <Tooltip/>
                        <Legend/>
                        <Bar name="PRIKAZOV" dataKey="ad_shown" stackId="a" fill="#8884d8"/>
                        <Bar name="KLIKOV" dataKey="ad_click" stackId="a" fill="#82ca9d"/>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        );
    }

    const renderAvgPriceRegionally = (regions) => {
        return (
            <div style={{height: '140px', width: '300px'}}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        width={500}
                        height={300}
                        data={regions}
                        margin={{
                            top: 0,
                            right: 0,
                            left: 0,
                            bottom: 0,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3"/>
                        <XAxis dataKey="region"/>
                        <YAxis/>
                        <Tooltip/>
                        <Legend/>
                        <Bar name="POVP. CENA" dataKey="avg_price" fill="#82ca9d"/>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        );
    }

    const displayStatsForHourlyQrScansToggle = () => {
        return (
            <div className={'stats-toggle prices-toggle custom-row'}>
                <>
                    <Button id={'button-all-bars'} selection
                            selected={!showStatsForSelectedBar}
                            text={'VSI BARI'}
                            action={() => setShowStatsForSelectedBar(false)}/>
                    <Button id={'button-selected-bar'} selection
                            selected={showStatsForSelectedBar}
                            text={'ZA IZBRANI BAR'}
                            action={() => setShowStatsForSelectedBar(true)}/>
                </>
            </div>
        );
    };


    const displayStatsToggle = () => {
        return (
            <div className={'stats-toggle custom-row'}>
                <>
                    <Button id={'button-digital'} selection
                            selected={!tab}
                            text={'ANALITIKA QR IN OGLASI'}
                            action={() => setTab(false)}/>
                    <Button id={'button-paper'} selection
                            selected={tab}
                            text={'ANALITIKA POVP. CEN'}
                            action={() => setTab(true)}/>
                </>
            </div>
        );
    }

    const displayStatsToggleCategoryProduct = () => {
        if (!tab) {
            return <></>
        }

        return (
            <div className={'stats-toggle prices-toggle custom-row'}>
                <>
                    <Button id={'button-digital'} selection
                            selected={!tabPrices}
                            text={'KATEGORIJE'}
                            action={() => setTabPrices(false)}/>
                    <Button id={'button-paper'} selection
                            selected={tabPrices}
                            text={'IZDELKI'}
                            action={() => setTabPrices(true)}/>
                </>
            </div>
        );
    }

    const renderCalendarModal = () => {
        if (!showCalendarModal) {
            return null;
        }
        return (
            <div className="modal-overlay">
                <div className="modal-content">
                    <div className="modal-header" style={{display: "flex", justifyContent: "space-between"}}>
                        <h2>Izberite časovno obdobje</h2>
                        <Button close text="X" action={() => setShowCalendarModal(false)}/>
                    </div>
                    <div className="modal-body">
                        <Calendar
                            onChange={setDateRange}
                            value={dateRange}
                            selectRange={true}
                        />
                    </div>
                    <div className="modal-footer">
                        <Button inline text="POTRDI" action={() => {
                            // Make sure we're in CUSTOM_TIME mode and have a valid date range
                            if (dateRange[0] && dateRange[1]) {
                                setPeriod("CUSTOM_TIME");
                                setShowCalendarModal(false);
                                // The API calls will be triggered by the useEffect that depends on period, startDate, and endDate
                            } else {
                                alert("Prosimo, izberite veljavno časovno obdobje");
                            }
                        }}/>
                    </div>
                </div>
            </div>
        );
    };

    const renderPeriodsToggle = () => {
        const formatDateRange = (range) => {
            const [start, end] = range;
            return `${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
        };

        const isCustomTimeSelected = period === "CUSTOM_TIME" && dateRange[0] && dateRange[1];

        return (
            <div className={'toggle-period custom-row'}>
                <>
                    <Button id={'button-digital'} selection
                            disabled={false}
                            selected={period === "7_DAYS"}
                            text={'7 DNI'}
                            action={() => setPeriod("7_DAYS")}/>
                    <Button id={'button-paper'} selection
                            selected={period === "30_DAYS"}
                            disabled={false}
                            text={'30 DNI'}
                            action={() => setPeriod("30_DAYS")}/>
                    <Button id={'button-both'} selection
                            disabled={false}
                            selected={period === "ALL_TIME"}
                            text={'CELOTNO OBDOBJE'}
                            action={() => setPeriod("ALL_TIME")}/>
                    <Button id={'button-third'} selection
                            disabled={false}
                            selected={period === "CUSTOM_TIME"}
                            text={'ČASOVNO OBDOBJE'}
                            action={() => {
                                setPeriod("CUSTOM_TIME");
                                setShowCalendarModal(true);
                            }}/>
                    {isCustomTimeSelected && (
                        <div className="date-range-container" style={{display: 'flex'}}>
                            <span className="date-range-text">{formatDateRange(dateRange)}</span>
                            <div
                                onClick={() => {
                                    setPeriod("ALL_TIME");
                                    setDateRange([new Date(), new Date()]);
                                }}
                                style={{marginLeft: '8px', cursor: 'pointer'}}>
                                X
                            </div>
                        </div>
                    )}
                </>
            </div>
        );
    }

    function Item(props) {
        console.log(props.value);
        const item = props.value;
        const regions = props.value.regions || [];
        
        return (
            <li onClick={() => {
            }} className={'row'}>
                <div className={'row-stat normal'}>{parseMapCaretChars(item.name)}</div>
                <div className={'row-stat normal'}>{item.ad_shown}</div>
                <div className={'row-stat normal'}>{item.ad_click}</div>
                <div className={'row-stat'}>{
                    renderAdImpressionsRegionally(regions)
                }</div>
            </li>
        );
    }

    function renderTable(items) {
        const header = () => {
            return (
                <>
                    <div className={'dynamic-header-stats'}>
                        <div className={'row-stat'}>Oglas</div>
                        <div className={'row-stat'}>Št. prikazov</div>
                        <div className={'row-stat'}>Št. klikov</div>
                        <div className={'row-stat'}>Regijska porazdelitev</div>
                    </div>
                </>
            );
        };
        // console.log(items);
        if (!items || items === {}) {
            return header();
        } else {
            const list = (items) => {
                if (!items) {
                    return;
                }
                return (
                    <ul className={'item-list dynamic stats-list'}>
                        {items.map((item, index) => <Item key={index} value={item}/>)}
                    </ul>
                );
            }
            return (
                <div className={'table-container-dynamic'}>
                    {header()}
                    {list(items)}
                </div>
            );
        }
    }

    function ItemAvgPrice(props) {
        // console.log(props.value);
        const item = props.value;
        const regions = props.value.regions;
        /*
        if (!item.scans_counter) {
            return <></>;
        }

         */
        return (
            <li onClick={() => {
            }} className={'row'}>
                <div className={'row-stat normal'}>{parseMapCaretChars(item.name)}</div>
                <div className={'row-stat'}>{item?.avg_price} €</div>
                <div className={'row-stat'}>{
                    renderAvgPriceRegionally(regions)
                }</div>
            </li>
        );
    }

    function renderTableAvgPrices(items, title) {
        const filters = () => {
            return (
                <div className={'search-filters'} style={{left: `${sidebarWidth + 50}px`}}>
                    <Input onSubmit={() => {
                    }}
                           onChange={setNameInput}
                           placeholder={'Naziv ali šifra izdelka ali kategorije'}
                           white
                    />
                </div>
            );
        };
        const pages = (className) => {
            return (
                <div className={className} style={{left: `${sidebarWidth + 50}px`}}>
                    <Button disabled={currentPage === 1}
                            text={'Prejšnja stran'}
                            action={() => {
                                setCurrentPage(currentPage - 1)
                            }}/>
                    <Button disabled={currentPage === Math.ceil(filteredAverageProductPrices.length / ITEMS_PER_PAGE)}
                            text={'Naslednja stran'}
                            action={() => {
                                setCurrentPage(currentPage + 1)
                            }}/>
                    <p>{currentPage}/{Math.ceil(filteredAverageProductPrices.length / ITEMS_PER_PAGE)}</p>
                </div>
            );
        };
        const header = () => {
            return (
                <>
                    <div className={'dynamic-header-stats col3'}>
                        <div className={'row-stat'}>{title}</div>
                        <div className={'row-stat'}>Povprečna cena</div>
                        <div className={'row-stat'}>Regijska porazdelitev</div>
                    </div>
                </>
            );
        };
        // console.log(items);
        if (!items || items === {}) {
            return header();
        } else {
            const list = (items) => {
                if (!items) {
                    return;
                }
                return (
                    <ul className={'item-list dynamic stats-list col3'}>
                        {items.map((item, index) => <ItemAvgPrice key={index} value={item}/>)}
                    </ul>
                );
            }
            return (
                <div className={'table-container-dynamic'} style={{display: !tab ? 'none' : 'block'}}>
                    {filters()}
                    {pages('pagination-container pagination-container-has-filter')}
                    {header()}
                    {list(items)}
                </div>
            );
        }
    }

    const renderAnalyticsAveragePrices = () => {
        return <>
            <p className={'p-title-small'}
               style={{
                   paddingBottom: '48px',
                   marginTop: '150px'
               }}>{'Analitika povprečnih cen kategorij in izdelkov'}</p>

            {!tabPrices ? <div className={'container-column-2'} style={{marginBottom: '20px'}}>
                    <div className={'column-2'} style={{width: '80%'}}>
                        <p className={'p-title-small'}>{'Kategorije'}</p>
                        {renderTableAvgPrices(averageCategoryPrices, "Kategorija")}
                    </div>
                </div> :
                <div className={'container-column-2'}>
                    <div className={'column-2'} style={{width: '80%', marginBottom: '20px'}}>
                        <p className={'p-title-small'}>{'Izdelki'}</p>
                        {renderTableAvgPrices(averageProductPrices, "Izdelek")}
                    </div>
                </div>
            }
        </>
    }

    const renderAdsImpressionsList = () => {
        return (
            <>
                <p className={'p-title-small'}
                   style={{marginTop: '24px', marginBottom: '12px'}}>{'Analitika oglasov'}</p>
                <div className={'custom-row'} style={{justifyContent: 'flex-start'}}>
                    {!adsImpressions || adsImpressions?.length === 0 ?
                        <p className={'p-stats-info'}>Za izbrano časovno obdobje ni podatkov.</p> : 
                        renderTable(adsImpressions)}
                </div>
            </>
        );
    }

    const renderAnalyticsScansAndAds = () => {
        return <>
            <div className={'container-column-2'}>
                <div className={'column-2'} style={{width: '50%'}}>
                    <p className={'p-title-small'}>{'Prikaz skeniranih QR kod (po dnevih)'}</p>
                    {renderScansDaily()}
                    <p className={'p-stats-info'}>{`Število skeniranih aktivnih cenikov za dano obdobje: ${dataQrScansDailySum}`}</p>
                </div>

                <div className={'column-2'} style={{width: '50%', paddingRight: '48px', paddingLeft: '36px'}}>
                    <p className={'p-title-small'}>{'Prikaz skeniranih QR kod (po urah)'}</p>
                    {renderScansHourly()}
                </div>
            </div>

            {renderPeriodsToggle()}

            <div className={'container-column-2'} style={{paddingTop: '48px'}}>
                <div className={'column-2'} style={{width: '50%'}}>
                    <p className={'p-title-small'}>{'Prikaz skeniranih QR kod (po regijah)'}</p>
                    {renderScansRegionally()}
                </div>
                <>
                    <div className={'column-2'} style={{width: '50%', paddingRight: '48px', paddingLeft: '36px'}}>
                        <p className={'p-title-small'}>{'Prikaz skeniranih QR kod (po urah) za izbrani bar'}</p>

                        <BarQrScansDropdown
                            options={dataQrScansByBarsHourly}
                            onChange={setSelectedBarForHourlyQrScans}
                            placeholder={"Izberite bar"}
                        />
                        {renderScansByBarHourly()}
                    </div>

                </>
            </div>

            {renderAdsImpressionsList()}
        </>
    }


    let documentSize = {x: document.documentElement.clientWidth, y: document.documentElement.scrollHeight}
    const [mainHeight, setMainHeight] = useState(documentSize.y);
    useEffect(() => {
        setTimeout(() => {
            let documentSize = {x: document.documentElement.clientWidth, y: document.documentElement.scrollHeight}
            setMainHeight(documentSize.y + 100);
        }, 250)
    }, [tab, tabPrices, selectedBarForHourlyQrScans])


    return !isSessionValid(token) ? <Redirect to={PAGES.LOGIN} push={false}/> :
        token &&
        <div><Page relative ad className={'main analytics'} style={{height: `${mainHeight}px`}}
                   onToggleSidebar={(shown) => {
                       if (shown) {
                           dispatch(setSidebarWidth(SIDEBAR_WIDTH))
                       } else {
                           dispatch(setSidebarWidth(0))
                       }
                   }}>
            <div className={'body'} style={{
                paddingLeft: `${sidebarWidth + 50}px`
            }}>
                <Header left={`${sidebarWidth + 50}px`} title={`ANALITIKA`}/>
                {displayStatsToggle()}
                {displayStatsToggleCategoryProduct()}

                {!tab ? renderAnalyticsScansAndAds() : renderAnalyticsAveragePrices()}
            </div>
            {renderCalendarModal()}
        </Page>
        </div>
}

export default Analytics;